<template>
  <div class="col-md-6" v-if="selectedAccount">
    <div class="d-flex">
      <h4 class="flex-fill">{{ selectedAccount.name }}</h4>
      <button class="btn btn-attention hide">Hide</button>
    </div>
    <div class="pt-3">
      <h5>Current Usage Summary</h5>
      <table class="table table-striped">
        <thead class="thead-dark">
        <tr><th>Team</th><th>Charge date</th><th>Current usage</th></tr>
        </thead>
        <tbody>
        <tr v-for="t in teams">
          <td>{{ t.name }}</td>
          <td>{{ dateString(t.budget.nextChargeTs * 1000) }}</td>
          <td>{{ t.budget.charges.toFixed(2) }}</td>
        </tr>
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">Subtotal</th>
            <th scope="row"></th>
            <th scope="row">{{ totalCharges.toFixed(2) }}</th>
          </tr>
          <tr v-if="selectedAccount.freeMonthlyCredit > 0">
            <th scope="row">Free credit</th>
            <th scope="row"></th>
            <td>{{ -freeCredit.toFixed(2) }}</td>
          </tr>
          <tr>
            <th scope="row">Total</th>
            <th scope="row"></th>
            <td>{{ (totalCharges-freeCredit).toFixed(2) }}</td>
          </tr>
        </tfoot>
      </table>
      <div v-if="records.length">
        <h5>Transaction History</h5>
        <table class="table table-striped">
          <thead class="thead-dark">
          <tr>
            <th>Operation</th>
            <th>Date</th>
            <th>Summary</th>
            <th>Amount</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="r in records">
            <td>{{ r.operation }}</td>
            <td>{{ dateString(r.ts) }}</td>
            <td>{{ r.comment }}</td>
            <td>{{ (r.amountCents / 100).toFixed(2) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import {BillingDto, BillingRecordDto, TeamDto} from "@/Teams";
import {BillingRecords, TeamList} from "@/Routes";
import {dateString} from "@/utils/Time";

@Component
export default class BillingAccountHistory extends Vue {
  private selectedAccount?: BillingDto = null;
  private dateString = dateString;
  private teams: TeamDto[] = [];
  private records: BillingRecordDto[] = [];
  private totalCharges = 0;
  private freeCredit = 0;

  public setSelectedAccount(acc: BillingDto) {
    this.selectedAccount = acc;
    this.reloadHistory();
  }

  private reloadHistory() {
    TeamList.invoke({ owned: true, participated: false }).then((teams: Array<TeamDto>) => {
      this.totalCharges = 0;
      this.freeCredit = 0;
      this.teams = teams
          .filter((team) => team.billingRefid === this.selectedAccount.refid)
          .sort((t1, t2) => t1.budget.nextChargeTs - t2.budget.nextChargeTs);
      this.teams.forEach(t => {
        this.totalCharges += t.budget.charges;
        this.freeCredit += Math.min(t.budget.charges, this.selectedAccount.freeMonthlyCredit ?? 0);
      });
    })
    BillingRecords.invoke({
      refid: this.selectedAccount.refid
    }).then((records: Array<BillingRecordDto>) => {
      this.records = records.sort((t1, t2) => t2.ts - t1.ts);
    });
  }

}
</script>

<style scoped lang="scss">
@import "sass/components/variables";

tfoot {
  tr {
    background-color: transparent !important;
  }
  border-top: solid $gp-light-brand 2px;
  border-bottom: solid $gp-light-brand 2px;
}
</style>

